module.exports = __webpack_public_path__ + "static/one-percent-swiper_bg-2c97e88b1165478d5665b7f37f3b22a2.png";